import * as React from "react";
import Collapsible from "react-collapsible";
import {Link} from "react-router-dom";

interface IProps {
  nodes: any[];
  traverseMethod: (branch: any) => void;
}
let curPath: string = "";

export class Treenode extends React.Component<IProps, any> {
  public sibling = (node: any) => {
    return (
      <Link to="/generators/folders" style={{display: "inline-block"}} onClick={() => this.props.traverseMethod([node])}>{/* tslint:disable-line */}
        {node.name}
      </Link>
    );
  };
  public render(): any {
    return (
      <div>
        {this.props.nodes.map((node, index) => {
          {
            curPath = curPath + "/" + node.name;
          }
          return (
            <li key={index}>
              {node.children.length > 0 && (
                <Collapsible
                  triggerSibling={() => this.sibling(node)} /* tslint:disable-line */
                  trigger={
                    node.children[0].children.length !== 0 ? (
                      <span className="icon">
                        <i className="fa fa-folder" />
                      </span>
                    ) : (
                      ""
                    )
                  }
                  triggerWhenOpen={
                    node.children[0].children.length !== 0 ? (
                      <span className="icon">
                        <i className="fas fa-folder-open" />
                      </span>
                    ) : (
                      ""
                    )
                  }
                >
                  <ul>
                    <Treenode nodes={node.children} traverseMethod={this.props.traverseMethod} />
                  </ul>
                  {(curPath = "")}
                </Collapsible>
              )}
            </li>
          );
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Sidebar/treenode.tsx